export const mapStyle = [];



// WEBPACK FOOTER //
// ./src/components/map/mapStyle.js